import Vue from 'vue';
import Vue2PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(Vue2PerfectScrollbar);
